import {Core} from '@strapi/strapi';
import {getRequireRoles} from "../utils/permission";
import {DeploymentType, GithubActionEnabledResponse, TriggerButtonInfo} from "../../types";

export default ({strapi}: { strapi: Core.Strapi }) => ({
  telegramBot: strapi.plugin('telegram-bot').service('telegram-bot'),
  async getButtons(apiID: string) {
    // @ts-ignore
    const actions = await strapi.admin.config.telegramActions;
    const {triggerButtons} = actions;
    let enabled = false;
    const requireRoles = await getRequireRoles(apiID);

    const buttons: TriggerButtonInfo[] = (triggerButtons || [])
      .filter((button) => button.singularName === apiID && (!button.roles || button.roles.length === 0 || button.roles.every((role) => requireRoles.includes(role))))
      .map(({
              buttonID,
              apiID,
              label,
              variant,
              roles
            }) => ({
        buttonID,
        apiID,
        label,
        variant,
        roles
      }));
    if (buttons.length > 0) {
      enabled = true;
    }

    return {
      enabled,
      buttons,
    } as GithubActionEnabledResponse;
  },

  sendNotification(data: any, actionType: DeploymentType) {
    const {botDocumentId} = data;
    this.telegramBot.sendMessage(botDocumentId, data, [], actionType).catch(strapi.log.error);
  },

  async trigger(buttonID: string, id: string) {
    // @ts-ignore
    const actions = await strapi.admin.config.telegramActions;
    const {triggerButtons} = actions
    let executed = false;

    const buttonInfo = triggerButtons.find((button) => button.buttonID === buttonID);
    const {enabled} = await this.getButtons(buttonInfo.singularName);
    if (!enabled) {
      return {
        executed,
      }
    }

    if (buttonInfo) {
      executed = true;
      const {singularName, environment} = buttonInfo;
      let actionType = DeploymentType.NOTIFICATION_PRODUCTION;
      if (environment === 'development') {
        actionType = DeploymentType.NOTIFICATION_DEVELOPMENT;
      }
      const contentSend = await strapi.services[singularName].getDataContent(id);
      const {status, message, data} = contentSend;
      if (!status) {
        return {
          type: 'warning',
          status: false,
          message
        }
      }

      try {
        this.sendNotification(data, actionType);
        return {
          type: 'success',
          status: true,
          message: 'Triggered successfully'
        }
      } catch (error) {
        console.error('Error on trigger', error);
        const data = error.response?.data;
        if (data && data.message) {
          return {
            type: 'warning',
            status: false,
            message: data.message
          }
        }
      }
    }
    return {
      type: 'warning',
      status: false,
      message: 'Not Found'
    }
  }
});
